/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Tool_Grants_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not load tool access for this space." |
*
* @param {Spaces_Tool_Grants_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_tool_grants_load_error = /** @type {((inputs?: Spaces_Tool_Grants_Load_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Tool_Grants_Load_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Tool-Zugriff für diesen Space konnte nicht geladen werden.")
	return /** @type {LocalizedString} */ ("Could not load tool access for this space.")
});